import AdminUsersPage from '../../../components/admin/users/AdminUsersPage'

export default function Users() {
  return <AdminUsersPage />
}
